import type { AxiosRequestConfig } from 'axios'
import { stringify } from 'qs'

const useApiPCFetch = () => {
  const { fetch: apiFetch } = useAPIFetch()
  const runtimeConfig = useRuntimeConfig()

  const fetch: <T>(config: AxiosRequestConfig, returnResponse?: boolean) => Promise<T> = (config) => {
    const params = { ...config.params }

    Object.keys(params).forEach((key) => {
      if (Array.isArray(params[key])) {
        const arrayValues = params[key]
        delete params[key]

        arrayValues.forEach((value, index) => {
          params[`${key}[${index}]`] = value
        })
      }
    })

    return apiFetch({
      baseURL: runtimeConfig.public.propertyCatalogueApiUrl,
      ...config,
      params: Object.fromEntries(new URLSearchParams(stringify(params))),
    })
  }

  return {
    fetch,
  }
}

export default useApiPCFetch
